import Lecture from './Lecture';

export default Lecture;
